<template>

    <div class="tw-m-5">

        <div class="tw-mb-1 tw-text-gray-600 label">Ankerpunt</div>

        <small class="tw-block tw-mb-3 tw-text-gray-500 label tw-text-muted">Vul hier een anchor in. Dit betreft het #
            deel achter een url. Hiermee kan je linken naar dit blok.</small>

        <input type="text"
               class="focus:tw-border-blue-300 focus:tw-outline-none focus:tw-shadow-outline-blue form-control form-input sm:tw-leading-5 sm:tw-text-sm tw-border tw-border-gray-300 tw-border-solid tw-duration-150 tw-ease-in-out tw-mt-1 tw-px-3 tw-py-2 tw-rounded-md tw-shadow-sm tw-transition tw-w-full"
               @input="$set(options, 'anchor', $event.target.value)"
               placeholder="categorie"
               :value="options.anchor"/>

    </div>

</template>

<script>

export default {

    props: {
        options: Object,
    },

}

</script>
